"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = formatNumber;
var _getFormattedNumber = require("../internals/getFormattedNumber");
var _makeSpacesNonBreakable = require("../internals/makeSpacesNonBreakable");
/**
 * Returns parameter `value` formatted as the number.
 *
 * The `value` is formatted in the runtime culture in case:
 * - the {@link culture} setting is not provided,
 * - the number formatting rules are not available in the {@link culture} setting.
 *
 * @param value Numeric value to format
 * @param culture Culture settings containing formatting rules
 * @param options Additional formatting options
 * @returns `value` formatted as general number
 * @example
  // basic usage
  import { formatNumber, useCulture } from '@ori/culture';
  const { culture } = useCulture();
  const formattedNumber = formatNumber(1234.567, culture);

  // specify number of decimals to display
  formatNumber(1234.567, culture, { decimals: 2 })
 */
function formatNumber(value, culture, options) {
  const {
    numberFormat
  } = culture ?? {};
  if (!numberFormat) {
    // it is preferred by the business to display the value formatted in the runtime culture than no value at all
    return value.toLocaleString();
  }
  return (0, _makeSpacesNonBreakable.makeSpacesNonBreakable)((0, _getFormattedNumber.getFormattedNumber)(value, options?.decimals ?? numberFormat.decimals, numberFormat.decimalSeparator, numberFormat.groupSizes, numberFormat.groupSeparator, {
    negativePattern: numberFormat.negativePattern
  }));
}
//# sourceMappingURL=formatNumber.js.map